<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
        offset-md="2"
        lg="6"
        offset-lg="3"
        xl="4"
        offset-xl="4"
      >
        <template v-if="section != null">
          <!-- <v-sheet color="primary" dark rounded>
            <div class="pa-3 text-center">
              <div class="subtitle-1">
                หมวดที่ {{ section.info.sectionNo }}/{{ section.totalSection }}
              </div>
            </div>
          </v-sheet> -->

          <div class="mt-4">
            <template v-for="question of section.questions">
              <question-component
                :id="`q_${question._id}`"
                :ref="`q_${question._id}`"
                :key="`q_${question._id}`"
                :question="question"
                :session-id="sessionId"
                :section-id="section.info.sectionId"
              >
              </question-component>
            </template>
          </div>

          <div class="mt-4">
            <div class="d-flex">
              <div>
                <v-btn
                  depressed
                  :disabled="section.info.sectionNo == 1"
                  @click="prevSection"
                  >Back</v-btn
                >
              </div>
              <v-spacer></v-spacer>
              <div>
                <template v-if="!isLastSection">
                  <v-btn depressed color="primary" @click="nextSection"
                    >Next</v-btn
                  >
                </template>
                <template v-else>
                  <v-btn depressed color="primary" @click="finishSession"
                    >Finish</v-btn
                  >
                </template>
              </div>
            </div>
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import stringHelper from "../helpers/string";
import QuestionComponent from "../components/QuestionComponent";
import sessionService from "../services/evaluateSession";
import EventBus from "../plugins/event-bus";
export default {
  components: {
    QuestionComponent,
  },
  beforeRouteEnter(to, from, next) {
    let token = sessionStorage.getItem("token");
    let course = sessionStorage.getItem("course");
    let numStamp = sessionStorage.getItem("numStamp");

    if (
      !stringHelper.isNullOrEmpty(token) &&
      !stringHelper.isNullOrEmpty(course) &&
      !stringHelper.isNullOrEmpty(numStamp)
    ) {
      next();
    } else {
      next({
        name: "error",
        params: {
          code: "0x003",
        },
      });
    }
  },
  data: () => ({
    section: null,
  }),
  computed: {
    isLastSection() {
      if (this.section == null) {
        return false;
      }
      return this.section.info.sectionNo == this.section.totalSection;
    },
    sessionId() {
      return sessionStorage.getItem("evalId");
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      EventBus.$emit("overlay", true);
      // get current section
      sessionService
        .getSection(this.sessionId)
        .then((resp) => {
          this.section = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          EventBus.$emit("overlay", false);
        });
    },
    prevSection() {
      EventBus.$emit("overlay", true);
      sessionService
        .prevSection(this.sessionId)
        .then((resp) => {
          this.section = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          EventBus.$emit("overlay", false);
        });
    },
    nextSection() {
      if (this.validateQuestion() == true) {
        EventBus.$emit("overlay", true);
        sessionService
          .nextSection(this.sessionId)
          .then((resp) => {
            this.section = resp.data;
          })
          .catch((error) => {
            console.error(error);
            // show dialog is end
          })
          .finally(() => {
            EventBus.$emit("overlay", false);
          });
      }
    },
    validateQuestion() {
      let shouldGoNext = true;
      let firstError = null;
      for (const question of this.section.questions) {
        let refName = `q_${question._id}`;
        let result = this.$refs[refName][0].validate();

        if (result == false) {
          shouldGoNext = false;
          if (firstError == null) {
            firstError = "#" + refName;
          }
        }
      }

      // scroll to first error
      if (firstError != null) {
        this.$vuetify.goTo(firstError, { offset: 16 });
      }

      return shouldGoNext;
    },
    finishSession() {
      if (this.validateQuestion() == true) {
        // call ajax summary
        EventBus.$emit("overlay", true);
        sessionService
          .finishSession(this.sessionId)
          .then((resp) => {
            this.$router.replace({
              name: "report",
            });
          })
          .catch((error) => {
            console.error(error);
            // show dialog is end
          })
          .finally(() => {
            EventBus.$emit("overlay", false);
          });
      } else {
        // show dialog
      }
    },
  },
};
</script>